// src/services/packageService.js
import api from './api';

const packageService = {
  // Récupérer tous les forfaits avec filtres et pagination
  getPackages: async (params = {}) => {
    const response = await api.get('/packages', { params });
    return response.data;
  },
  
  // Récupérer un forfait par son ID
  getPackageById: async (id) => {
    const response = await api.get(`/packages/${id}`);
    return response.data;
  },
  
  // Récupérer les forfaits pour l'administration
  getAdminPackages: async (params = {}) => {
    const response = await api.get('/packages/admin/list', { params });
    return response.data;
  },
  
    // Créer un nouveau forfait

    createPackage: async (packageData) => {
      const response = await api.post('/packages', packageData);
      return response.data;
    },
    
  // Mettre à jour un forfait existant
  updatePackage: async (id, packageData) => {
    
    // Vérifier si packageData est déjà un FormData
    if (packageData instanceof FormData) {
      console.log('FormData détecté');
      const response = await api.put(`/packages/${id}`, packageData, {
        headers: {
          'Content-Type': undefined // Supprimer l'en-tête pour laisser Axios le définir
        },
      });
      return response.data;
    } else {
      // Si c'est un objet JS normal
      const response = await api.put(`/packages/${id}`, packageData);
      return response.data;
    }
  },
  
  // Supprimer un forfait
  deletePackage: async (id) => {
    const response = await api.delete(`/packages/${id}`);
    return response.data;
  },
};

export default packageService;